// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__5GVCt","head":"ProcedureTableInfo_head__W7-Cg"};